/**
 * Интерфейс луғати: ўзбек (кирилл).
 * Калитлар ru.js билан мос бўлиши керак. APIга каноник қийматлар юборилади.
 */
export default {
  header_filters: 'Филтрлар',
  header_done: 'Қўллаш',
  filters_close: 'Филтрларни ёпиш',
  header_city_title: 'Шаҳарни танланг',
  header_language: 'Тил',
  header_outreach: 'Тарқатма',
  header_outreach_title: 'Telegram тарқатма дашборди',
  header_debug: 'Debug',
  header_debug_title: 'Харита debug режими (манзилдаги ?debug= каби): геокодлаш маълумотлари, аввалги координаталар ва яширилган эълонлар',
  loading: 'Филтрлар юкланмоқда…',

  placeholder_min: 'мин',
  placeholder_max: 'макс',
  common_any_value: 'Ҳар қандай',
  common_yes: 'Ҳа',
  common_no: 'Йўқ',
  common_any_type: 'Ҳар қандай тури',
  common_any_type_plot: 'Ҳар қандай участка тури',
  common_any_type_house: 'Ҳар қандай уй тури',
  common_any_layout: 'Ҳар қандай планировка',
  common_any_bathroom: 'Ҳар қандай ҳожатхона',
  common_any_renovation: 'Ҳар қандай таъмир',
  common_gas_any: 'Газли ва газсиз',
  common_any_heating: 'Ҳар қандай иситиш',
  common_any_purpose: 'Ҳар қандай мақсад',
  common_any_location: 'Ҳар қандай жойлашув',
  common_any_finishing: 'Ҳар қандай битими',
  common_any_facade: 'Ҳар қандай фасад',
  common_any_parking: 'Ҳар қандай парковка',
  common_any_stage: 'Ҳар қандай босқич',
  common_any_class: 'Ҳар қандай синф',

  filters_price: 'Нарх',
  filters_commission_up_to: 'Комиссия ҳадгача',
  filters_rooms: 'Ҳоналар сони',
  filters_area_total: 'Умумий майдон, м²',
  filters_area_living: 'Яшаш майдони, м²',
  filters_area_kitchen: 'Ошхона майдони, м²',
  filters_area_usable: 'Фойдаланиладиган майдон, м²',
  filters_plot_area: 'Участка майдони, соти',
  filters_floor: 'Қават',
  filters_floors_total: 'Бино қаватлиги',
  filters_ceiling: 'Шамолош баландлиги, м',
  filters_year_built: 'Қурилиш йили',
  filters_housing_type: 'Ҳона тури',
  filters_building_type: 'Қурилиш тури',
  filters_layout: 'Планировка',
  filters_bathroom: 'Ҳожатхона',
  filters_furnished: 'Мебел билан',
  filters_renovation: 'Таъмир',
  filters_gas: 'Газ',
  filters_features_inside: 'Квартирада бор',
  filters_features_inside_commercial: 'Жойда бор',
  filters_features_nearby: 'Яқинда бор',
  filters_plot_features: 'Уйда / участкада бор',
  filters_house_conditions: 'Уй ҳолати',
  filters_water: 'Сув',
  filters_heating: 'Иситиш',
  filters_communications: 'Алоқа',
  filters_realty_type: 'Кўчмас мулк тури',
  filters_house_location: 'Жойлашув',
  filters_land_purpose: 'Мақсад',
  filters_plot_type: 'Участка тури',
  filters_garage_type: 'Тур',
  filters_garage_purpose: 'Мақсад',
  filters_commercial_location: 'Жойлашув',
  filters_commercial_has_plot: 'Участка',
  filters_electricity: 'Электр',
  filters_has_parking: 'Парковка',
  filters_house_type: 'Уй тури',
  filters_housing_class: 'Ҳона синфи',
  filters_blocks_count: 'Корпуслар сони',
  filters_finishing: 'Битими',
  filters_facade: 'Фасад',
  filters_parking_type: 'Парковка',
  filters_construction_stage: 'Қурилиш босқичи',
  filters_parking_slots_from: 'Машина жойлари сони',
  filters_installment: 'Рассрочка',
  filters_mortgage: 'Ипотека',

  balloon_no_photo: 'Расм йўқ',
  carousel_prev: 'Олдинги',
  carousel_next: 'Кейинги',
  debug_section_title: 'Debug маълумотлар',
  debug_description: 'Тавсиф',
  debug_geocoded_by: 'Геокод манбаси',
  debug_geocoded: 'Geocoded',
  debug_landmarks_anomalies: 'Landmarks anomalies',
  debug_landmarks_approved: 'Landmarks approved',
  debug_geocoding_requests: 'Geocoding requests',
  debug_change_link: 'Локацияни ўзгартириш учун шахсий ҳавола',
  debug_regeocode_button: 'Regeocode',
  debug_regeocode_status_running: 'Қайта геокодлаш...',
  debug_regeocode_status_done: 'Тайёр: геомаълумот янгиланди',
  debug_regeocode_status_error: 'Қайта геокодлаш хатоси',
  debug_regeocode_status_unchanged: 'Координаталар ўзгармади',
  debug_regeocode_flash_unchanged: 'Координаталар ўзгармади',
  debug_toggle_on: 'Debug режими ёқилди',
  debug_toggle_off: 'Debug режими ўчирилди',

  // Локацияни ўзгартириш режими (?change=...)
  change_button: 'Локацияни ўзгартириш',
  change_pick_hint: 'Янги локацияни танлаш учун харитани босинг',
  change_cancel: 'Бекор қилиш',
  change_confirm_title: 'Янги локация сақлансинми?',
  change_confirm_hint: 'Нуқтани аниқлаштириш учун суриб бўлади',
  change_confirm: 'Тасдиқлаш',
  change_saving: 'Сақланмоқда...',
  change_save_done: 'Локация янгиланди',
  change_save_error: 'Локацияни сақлаб бўлмади',
  change_hide_button: 'Яшириш',
  change_show_button: 'Кўрсатиш',
  change_hide_confirm_title: 'Эълон яширилсинми?',
  change_show_confirm_title: 'Эълон кўрсатилсинми?',
  change_hide_confirm_hint: 'Эълон оддий фойдаланувчиларга харитада кўринмай қолади',
  change_show_confirm_hint: 'Эълон яна ҳаммага кўринади',
  change_hide_done: 'Эълон яширилди',
  change_show_done: 'Эълон кўрсатилди',
  change_hide_error: 'Кўринишни ўзгартириб бўлмади',
  balloon_hidden_banner: 'Эълон яширилган',

  // Бир марталик ҳавола орқали авторизация
  auth_menu_title: 'Профил',
  auth_logout: 'Чиқиш',
  auth_login_success: 'Тизимга кирдингиз — эълонларингиз тўқ сариқ рангда ажратилган. Локацияни ўзгартириш ёки яшириш учун ўз эълонингизни очинг',
  auth_login_success_no_hide: 'Тизимга кирдингиз — эълонларингиз тўқ сариқ рангда ажратилган. Локацияни ўзгартириш учун ўз эълонингизни очинг',
  auth_login_error: 'Кириш ҳаволаси яроқсиз ёки эскирган',
  auth_logged_out: 'Тизимдан чиқдингиз',

  // Муаллифнинг ўз эълонини таҳрирлаши (шахсий login-ҳавола орқали кириш)
  author_card_hint: 'Бу сизнинг эълонингиз: локацияни ўзгартириш ёки харитадан яшириш мумкин',
  author_card_hint_no_hide: 'Бу сизнинг эълонингиз: локацияни ўзгартириш мумкин',
  author_save_done: 'Раҳмат! Эълонингиз локацияси янгиланди',
  author_hide_done: 'Эълон харитадан яширилди. «Кўрсатиш» тугмаси орқали қайтариш мумкин',
  author_session_expired: 'Сақлаб бўлмади: кириш муддати тугаган. Хабардаги ҳаволани қайта очинг',

  city_andijan: 'Андижон',
  city_bukhara: 'Бухоро',
  city_guliston: 'Гулистон',
  city_jizzakh: 'Жиззах',
  city_karshi: 'Қарши',
  city_navoi: 'Навоий',
  city_namangan: 'Наманган',
  city_nukus: 'Нукус',
  city_samarkand: 'Самарқанд',
  city_tashkent: 'Тошкент',
  city_termez: 'Термез',
  city_urgench: 'Урганч',
  city_fergana: 'Фарғона',

  // Значения опций вынесены в locales/opt/*.js
}
